import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { pageRoutes } from "../../constants";
import { submitButtonSx } from "../../components/Auth/common";

// Shown once the account is created. One from an invitation can be used straight away; any other can't be used until
// the email is verified and GGF approves it
export default function RegistrationReceived({ firstName, email, organisationName, isNewOrganisation, isInvited }) {
  const navigate = useNavigate();

  const emailAddress = (
    <Box component="span" sx={{ color: "text.primary", fontWeight: 600, wordBreak: "break-all" }}>
      {email}
    </Box>
  );

  if (isInvited) {
    return (
      <>
        <Typography variant="h5" fontWeight="600" sx={{ mb: 2, color: "primary.main" }}>
          You’re all set, {firstName}!
        </Typography>

        <Typography sx={{ color: "text.secondary" }}>
          Your account in {organisationName} is ready. Sign in with {emailAddress} to get started.
        </Typography>

        <Button fullWidth variant="contained" onClick={() => navigate(pageRoutes.LOGIN)} sx={{ ...submitButtonSx, mb: 1 }}>
          Sign in
        </Button>
      </>
    );
  }

  return (
    <>
      <Typography variant="h5" fontWeight="600" sx={{ mb: 2, color: "primary.main" }}>
        Thanks for registering, {firstName}!
      </Typography>

      <Typography sx={{ mb: 2, color: "text.secondary" }}>
        We’ve sent a verification link to {emailAddress}. Please verify your email address.
      </Typography>

      <Typography sx={{ color: "text.secondary" }}>
        Group & General Finance will now review your registration
        {isNewOrganisation ? ` and add ${organisationName} to the broker portal` : ` to join ${organisationName}`}.
        We’ll email you once it’s approved, and you can then sign in.
      </Typography>

      <Button fullWidth variant="contained" onClick={() => navigate(pageRoutes.LOGIN)} sx={{ ...submitButtonSx, mb: 1 }}>
        Back to login
      </Button>
    </>
  );
}
